import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { GetScenariosResponse } from '../models/home-page.interface';
import config from '../../../../config.js';
@Injectable({
  providedIn: 'root',
})
export class HomePageService {
  baseUrl = config.API_GATEWAY_ENDPOINT;
  constructor(private http: HttpClient) {}

  async getScenarios(): Promise<GetScenariosResponse> {
    console.log(this.baseUrl);
    console.log(config);
    console.log(this.baseUrl);
    const scenarios = lastValueFrom(
      this.http.get<GetScenariosResponse>(`${this.baseUrl}/scenarios`)
    );
    return scenarios;
  }
}
